/**
 * useTelemetry
 *
 * Thin React hook that exposes telemetry helpers with stable
 * references (no re-render side-effects). Import this instead
 * of the service directly inside components.
 */
import { useCallback } from "react";
import {
  trackEvent,
  trackException,
  trackPageView,
  setAuthenticatedUser,
  clearAuthenticatedUser,
  startTimer,
  type EventProperties,
  type EventMeasurements,
} from "@/services/telemetry";

export function useTelemetry() {
  const track = useCallback(
    (name: string, properties?: EventProperties, measurements?: EventMeasurements) => {
      trackEvent(name, properties, measurements);
    },
    []
  );

  const trackError = useCallback((error: unknown, properties?: EventProperties) => {
    trackException(error, properties);
  }, []);

  const trackPage = useCallback((name: string, url?: string, properties?: EventProperties) => {
    trackPageView(name, url, properties);
  }, []);

  return {
    track,
    trackError,
    trackPage,
    setAuthenticatedUser,
    clearAuthenticatedUser,
    startTimer,
  };
}
